import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App.js'
import './boot/bootFont.css'
import './styles/global.css'

// 새로고침 때 브라우저가 스크롤을 복원하면, 하객은 로딩 화면 뒤에서 이미
// 문서 한가운데(히어로 스크럽은 끝까지 감기고, 지도 관찰자는 타일을 끌어오는 중)에
// 서 있게 된다. 복원은 우리가 하지 않는다 — 청첩장은 늘 처음부터 시작한다.
if ('scrollRestoration' in history) history.scrollRestoration = 'manual'

const root = document.getElementById('root')
if (root === null) throw new Error('#root not found')
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
